import gql from 'graphql-tag'

export const allLots = gql`
    query allLots ($installationId: ID!) {
        allLots(
            filter: {
                installationId: $installationId
            }
            orderBy: name_ASC
        ) {
            id
            name
            description
            type
            createdAt
            capacity
            address
            walkingDistanceMinutes
            avgPickupMinutes
        }
    }
`

export const lotById = gql`
    query lotById ($lotId: ID!) {
        lot(id: $lotId) {
            id
            name
            description
            type
            createdAt
            capacity
            address
            walkingDistanceMinutes
            avgPickupMinutes
            createdBy {
                name
            }
        }
    }
`



export const createLotMutation = gql`
    mutation createLot (
        $installationId: ID!
        $name: String!
        $description: String!
        $type: LotType
        $capacity: Int
        $address: String
        $walkingDistanceMinutes: Int
        $avgPickupMinutes: Int
    ) {
        createLot (
            lot: {
                installationId: $installationId
                name: $name
                description: $description
                type: $type
                capacity: $capacity
                address: $address
                walkingDistanceMinutes: $walkingDistanceMinutes
                avgPickupMinutes: $avgPickupMinutes
            }
        ) {
            id
            name
        }
    }
`


export const updateLotMutation = gql`
    mutation updateLot (
        $id: ID!
        $name: String
        $description: String
        $type: LotType
        $capacity: Int
        $address: String
        $walkingDistanceMinutes: Int
        $avgPickupMinutes: Int
    ) {
        updateLot (
            lot: {
                id: $id
                name: $name
                description: $description
                type: $type
                capacity: $capacity
                address: $address
                walkingDistanceMinutes: $walkingDistanceMinutes
                avgPickupMinutes: $avgPickupMinutes
            }
        ) {
            id
            name
        }
    }
`


export const defaultLot = gql`
    query defaultLot ($installationId: ID!) {
        defaultLot (installationId: $installationId) {
            installationId
            avgPickupMinutes
        }
    }
`

export const updateDefaultLotMutation = gql`
    mutation updateDefaultLot (
        $installationId: ID!
        $avgPickupMinutes: Int
    ) {
        updateDefaultLot (
            lot: {
                installationId: $installationId
                avgPickupMinutes: $avgPickupMinutes
            }
        ) {
            installationId
            avgPickupMinutes
        }
    }
`
